import React from 'react';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import BaseInputWrapper from '../BaseInputWrapper';
import useDefaultInputHook from '../hooks/useDefaultInputHook';
import InputProps from '../InputProps';

interface Props extends InputProps<string> {
  type?: string;
}

const TextField = ({
  inputName,
  inputLabel,
  onChange,
  defaultValue = '',
  type = 'text',
  inputError = false,
  inputErrorMessage = '',
  isDisabled = false,
}: Props): JSX.Element => {
  const inputId = `text-field-${inputName}`;
  const { currentClass, decoration, onInputChanged, onBlur } =
    useDefaultInputHook(inputError, defaultValue);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = event.target.value;
    onInputChanged(newValue);
    onChange(newValue);
  };

  return (
    <BaseInputWrapper
      inputId={inputId}
      label={inputLabel}
      error={inputError}
      errorMessage={inputErrorMessage}
    >
      <Input
        id={inputId}
        name={inputName}
        className={currentClass}
        disabled={isDisabled}
        value={defaultValue}
        onChange={handleChange}
        onBlur={onBlur}
        type={type}
        endAdornment={
          <InputAdornment position="end">{decoration}</InputAdornment>
        }
      />
    </BaseInputWrapper>
  );
};

export default TextField;
